import { createContext } from 'react';

// Default value prevents crashes in Storybook and other contexts where provider is missing
const AppContext = createContext({
    ref: {},
    toggleTheme: () => {}
});

export default AppContext;
